import React from 'react';
import EditableSchedule from './EditableSchedule';

function Schedule({ schedule, setSchedule }) {
  return (
    <section className="section" id="schedule">
      <h2 className="section-title">Schedule</h2>
      <EditableSchedule schedule={schedule} onChange={setSchedule} />
    </section>
  );
}

export default Schedule;